import parse from "html-react-parser";

export const isEmpty = (val, errorMessage) => {
    if (val !== undefined && val !== null && val.length > 0)
        return null;
    return errorMessage;
}

export const isSeatNumber = (val, errorMessage, emptyMessage) => {
    // if (val != null)
    //     val = val.replace("_", "");
    // if (val?.length === 1 || val?.length === 2) {
    //     if ('ABCDEFGHIJK'.indexOf(0) >= 0) return errorMessage;
    //     return null;
    // } else
    if (val?.length > 3) {
        return errorMessage;
    } else if (val?.length === 0) {
        return emptyMessage;
    } else {
        if (val !== null) {
            let last = val[val?.length - 1];
            if ('ABCDEFGHIJK'.indexOf(last) === -1) return errorMessage;
        }
    }
    return null;
}

export const rnd = (message) => {
    return message + ("_|" + Math.random());
}

export const errorRandomReplace = (error) => {
    if (error === undefined) return undefined;
    if (error === null) return null;
    let result = error;
    if (error.indexOf("_|") >= 0) {
        result = error.split("_|")[0];
    }
    return parse(result);
}
